/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ElasticsearchAnalyzerType = 'KoreanAnalyzerSearch' | 'KoreanAnalyzerIndex' | 'KoreanJamoEdgeNgramAnalyzerSearch' | 'KoreanJamoEdgeNgramAnalyzerIndex' | 'NgramAnalyzerSearch' | 'NgramAnalyzerIndex' | 'EdgeNgramAnalyzerSearch' | 'EdgeNgramAnalyzerIndex' | 'JamoNgramAnalyzerSearch' | 'JamoNgramAnalyzerIndex' | 'JamoEdgeNgramAnalyzerSearch' | 'JamoEdgeNgramAnalyzerIndex' | 'ChosungAnalyzerSearch' | 'ChosungAnalyzerIndex' | 'ChosungEdgeNgramAnalyzerIndex' | 'ChosungEdgeNgramAnalyzerSearch' | 'EngtokorAnalyzerIndex' | 'EngtokorAnalyzerSearch' | 'EngtokorEdgeNgramAnalyzerIndex' | 'EngtokorEdgeNgramAnalyzerSearch' | 'KortoengAnalyzerIndex' | 'KortoengAnalyzerSearch' | 'KortoengEdgeNgramAnalyzerIndex' | 'KortoengEdgeNgramAnalyzerSearch' | 'StandardAnalyzerSearch' | 'KeywordAnalyzerSearch' | 'SynonymAnalyzerSearch';

export const ElasticsearchAnalyzerType = {
    KoreanAnalyzerSearch: 'KoreanAnalyzerSearch' as ElasticsearchAnalyzerType,
    KoreanAnalyzerIndex: 'KoreanAnalyzerIndex' as ElasticsearchAnalyzerType,
    KoreanJamoEdgeNgramAnalyzerSearch: 'KoreanJamoEdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    KoreanJamoEdgeNgramAnalyzerIndex: 'KoreanJamoEdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    NgramAnalyzerSearch: 'NgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    NgramAnalyzerIndex: 'NgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    EdgeNgramAnalyzerSearch: 'EdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    EdgeNgramAnalyzerIndex: 'EdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    JamoNgramAnalyzerSearch: 'JamoNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    JamoNgramAnalyzerIndex: 'JamoNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    JamoEdgeNgramAnalyzerSearch: 'JamoEdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    JamoEdgeNgramAnalyzerIndex: 'JamoEdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    ChosungAnalyzerSearch: 'ChosungAnalyzerSearch' as ElasticsearchAnalyzerType,
    ChosungAnalyzerIndex: 'ChosungAnalyzerIndex' as ElasticsearchAnalyzerType,
    ChosungEdgeNgramAnalyzerIndex: 'ChosungEdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    ChosungEdgeNgramAnalyzerSearch: 'ChosungEdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    EngtokorAnalyzerIndex: 'EngtokorAnalyzerIndex' as ElasticsearchAnalyzerType,
    EngtokorAnalyzerSearch: 'EngtokorAnalyzerSearch' as ElasticsearchAnalyzerType,
    EngtokorEdgeNgramAnalyzerIndex: 'EngtokorEdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    EngtokorEdgeNgramAnalyzerSearch: 'EngtokorEdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    KortoengAnalyzerIndex: 'KortoengAnalyzerIndex' as ElasticsearchAnalyzerType,
    KortoengAnalyzerSearch: 'KortoengAnalyzerSearch' as ElasticsearchAnalyzerType,
    KortoengEdgeNgramAnalyzerIndex: 'KortoengEdgeNgramAnalyzerIndex' as ElasticsearchAnalyzerType,
    KortoengEdgeNgramAnalyzerSearch: 'KortoengEdgeNgramAnalyzerSearch' as ElasticsearchAnalyzerType,
    StandardAnalyzerSearch: 'StandardAnalyzerSearch' as ElasticsearchAnalyzerType,
    KeywordAnalyzerSearch: 'KeywordAnalyzerSearch' as ElasticsearchAnalyzerType,
    SynonymAnalyzerSearch: 'SynonymAnalyzerSearch' as ElasticsearchAnalyzerType
};

